// Frame.io V4 public share links. Keep in sync with the backend copy
// (../autoclipper-backend/src/lib/frameio/url.js) — both run
// frameioLinkTestVectors.json.
const UUID = '[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}';
const SHARE_PATH = new RegExp(`^/share/(${UUID})(?:/(?:view/(${UUID})|(${UUID})))?/?$`);

export type FrameioLink =
  | { kind: 'not_frameio' }
  | { kind: 'unsupported' }
  | { kind: 'share'; shareId: string; folderId: string | null; assetId: string | null };

function parseUrl(value: string): URL | null {
  if (typeof value !== 'string' || !value.trim()) return null;
  const trimmed = value.trim();
  try {
    return new URL(/^[a-z][a-z0-9+.-]*:/i.test(trimmed) ? trimmed : `https://${trimmed}`);
  } catch {
    return null;
  }
}

function isFrameioHost(hostname: string): boolean {
  const host = hostname.toLowerCase();
  return host === 'f.io' || host === 'frame.io' || host.endsWith('.frame.io');
}

export function isFrameioUrl(value: string): boolean {
  const url = parseUrl(value);
  return Boolean(url && isFrameioHost(url.hostname));
}

export function parseFrameioUrl(value: string): FrameioLink {
  const url = parseUrl(value);
  if (!url || !isFrameioHost(url.hostname)) return { kind: 'not_frameio' };
  if (url.protocol !== 'https:' || url.hostname.toLowerCase() !== 'next.frame.io'
    || url.username || url.password || url.port) {
    return { kind: 'unsupported' };
  }
  const match = url.pathname.match(SHARE_PATH);
  if (!match) return { kind: 'unsupported' };
  return {
    kind: 'share',
    shareId: match[1].toLowerCase(),
    folderId: match[3] ? match[3].toLowerCase() : null,
    assetId: match[2] ? match[2].toLowerCase() : null,
  };
}
